export const TAU = Math.PI * 2;
export const PHI = (1 + Math.sqrt(5)) / 2;
export const DEG2RAD_FACTOR = TAU / 360;

export function clamp(v)
{
    return v < 0 ? 0 : v > 1 ? 1 : v;
}
